import _toConsumableArray from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useLayoutEffect, useEffect } from 'react';
import { ToasterSystemContext } from './context';
var MAX_NO_TOASTS = 4;
export var ToasterSystem = function ToasterSystem(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      toastGroup = _useState2[0],
      addToastGroup = _useState2[1];

  var addToast = function addToast(toast) {
    var newToast = Object.assign({
      id: Date.now()
    }, toast);
    addToastGroup([newToast].concat(_toConsumableArray(toastGroup)));
  };

  var removeToast = function removeToast(toastId) {
    addToastGroup(toastGroup.filter(function (_ref2) {
      var id = _ref2.id;
      return id !== toastId;
    }));
  };

  useLayoutEffect(function () {
    if (toastGroup.length > 4) {
      addToastGroup(toastGroup.slice(0, MAX_NO_TOASTS));
    }
  }, [toastGroup]);
  useEffect(function () {
    var interval = setInterval(function () {
      if (toastGroup.length > 0) {
        removeToast(toastGroup[0].id);
      }
    }, 5000);
    return function () {
      clearInterval(interval);
    };
  }, [toastGroup]);
  return React.createElement(ToasterSystemContext.Provider, {
    value: {
      removeToast: removeToast,
      addToast: addToast,
      toastGroup: toastGroup
    }
  }, children);
};